import React from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, Box, Typography } from '@mui/material';
import { Header } from '../../../../../../components/header';
import { AnimatedBox } from '../../components/animated-box/animated-box';
import { useWhatsNew } from '../../hooks/use-whats-new';

type DashboardWhatsNewProps = {
  visibleMode?: boolean;
};

export const DashboardWhatsNew: React.FC<DashboardWhatsNewProps> = ({ visibleMode }) => {
  const { t } = useTranslation('dashboard');
  const { whatsNewData } = useWhatsNew();

  if (!visibleMode && !whatsNewData.length) return null;

  return (
    <Box paddingLeft={3} paddingRight={3}>
      <Header title={t('whatsNew.header')} />

      {whatsNewData.length ? (
        <AnimatedBox
          marginBottom={6}
          padding={2}
          sx={{
            borderRadius: 2,
            background: `linear-gradient(135deg, color-mix(in srgb, var(--color-accent) 60%, #f5f5f5) 0%, color-mix(in srgb, var(--color-accent) 40%, #e0e0e0) 100%)`,
          }}
        >
          <Box
            sx={{
              background: 'rgba(255, 255, 255, 0.85)',
              borderRadius: 2,
              padding: '8px 16px',
            }}
          >
            <List sx={{ paddingLeft: 3, listStyleType: 'disc' }}>
              {whatsNewData.map(({ id, title }) => (
                <ListItem
                  key={id}
                  sx={{
                    padding: '8px 0',
                    display: 'list-item',
                    color: '#000',
                  }}
                >
                  <Typography sx={{ color: '#000' }}>{title}</Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        </AnimatedBox>
      ) : null}
    </Box>
  );
};
